// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_newpageContent__lxhXc {
    display: flex;
    justify-content: space-between;
    margin-top: 0;
    /* min-height: calc(100vh - 67px); */
    min-height: 100vh;
}

.page_disabledNewpageLeft__3Azvl{
    pointer-events: none;
}

.page_newpageRight__cvvx3 {
    border-left: 1px solid #e6e6e6;
    margin-top: 0;
    max-height: calc(100vh - 67px);
    /* min-height: 100vh; */
    padding: 0;
    overflow-y: auto;
    position: relative;
    width: 410px;
}

.page_newpageLeft__oHlt9 {
    max-height: calc(100dvh - 100px);
    overflow-y: auto;
    /* margin-right: 36px; */
    padding-right: 40px;
    padding-left: 40px;
    width: calc(100% - 410px);
    padding-top: 30px;
}

.page_buttonsDesktop__Q0Iq3 {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: block;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.page_buttonsMobile__OjOU6 {
    border-bottom: 1px solid #e6e6e6;
    padding: 20px 30px;
    display: none;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
}

.page_newpageRightButtons__Sunh1 {
    display: inline-flex;
    position: relative;
    height: 44px;
}

.page_newpageRightButtons__Sunh1 button {
    font-family: 'CyGrotesk-KeyRegular';
}

.page_newpageRightButtons__Sunh1 button:first-child {
    border-radius: 6px;
}

.page_newpageRightButtons__Sunh1 button:first-child {
    border-radius: 4px;
    background: #0a0a0a;
}

.page_newpageRightButtons__Sunh1 button:first-child {
    /* background: #0a0a0a; */
    margin-right: 8px;
    /* min-width: 69px; */
    min-height: 42px;
    position: relative;
    justify-content: center;
    border-radius: 6px !important;
}

.page_newpageRightButtons__Sunh1 .page_publishButton__44uWf {
    width: 97.3px;
}

.page_newpageRightButtons__Sunh1 button {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    display: flex;
    gap: 8px;
    /* border-radius: 6px; */
    align-items: center;
    padding: 10px;
    /* border: none; */
    /* color: #fff; */
    cursor: pointer;
}

.page_primaryButton__q4DRZ {
    box-shadow: 0 1px 3px #0000001a;
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
}

.page_newpageRightButtons__Sunh1 button:first-child p {
    font-weight: 500;
    margin: 0;
}

.page_newpageRightButtons__Sunh1 button:nth-child(2) {
    margin-right: 8px;
}

.page_newpageRightButtons__Sunh1 .page_draftButton__80G-9 {
    width: 120px;
}

.page_secondaryButton__WyTt6 {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
}

.page_updatePagebtn__sw\\+iX {
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
    box-shadow: 0 1px 3px #0000001a;
}

.page_updateDraftButton__1tL7S {
    background-color: #000;
    color: #fff;
    border-radius: 6px;
    border: 1px solid #000;
    box-shadow: 0 1px 3px #0000001a;
}

.page_newpageMoreButtons__Pts8S {
    background-color: #fff;
    color: #344054;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
    width: 44px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.page_actionDots__IcHDJ {
    width: 16px;
    height: 16px;
}

.page_buttonsMobile__OjOU6 .page_publishedButtonsList__0qaGl {
    top: -90px;
}

.page_publishedButtonsList__0qaGl {
    position: absolute;
    top: 50px;
    right: 0;
    background: #fff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 10;
    min-width: 150px;
}

.page_publishedButtonsList__0qaGl ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.page_publishedButtonsList__0qaGl li {
    padding: 10px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #344054;
}

.page_publishedButtonsList__0qaGl li:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.page_publishedButtonsList__0qaGl li:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.page_publishedButtonsList__0qaGl li:hover {
    background-color: #f9fafb;
}

.page_publishStatus__OWcDW {
    margin-top: 10px;
    font-size: 14px;
    color: #344054;
    margin-bottom: 0;
}

.page_publishButton__44uWf {
    width: 97.3px;
}

.page_updatePagebtn__sw\\+iX {
    width: 74.83px;
}

.page_updateDraftButton__1tL7S {
    width: 116.92px;
}

.page_draftButton__80G-9 {
    width: 120px;
}

.page_ringLoader__nvw5P {
    width: 20px;
    height: 20px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #000;
    border-radius: 50%;
    animation: page_spin__YhGqv 1s linear infinite;
}

@keyframes page_spin__YhGqv {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.page_newpageRight__cvvx3>.page_newPageRightRow__\\+4WxM {
    border-bottom: 1px solid #e6e6e6;
    border-top: 0;
    overflow: hidden;
    padding: 20px 30px;
}

.page_newPageRightFullUrl__CG\\+gu,
.page_newPageRightTitle__Sg40q {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
}

.page_iconDropWrap__05wCG {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 0;
}

.page_iconDropWrap__05wCG span {
    font-weight: 500;
    margin-right: 3px;
    width: calc(100% - 15px);
    display: block;
}

.page_newPageRight__kT3q9:has(.page_expanded__9LsFk) .page_dropdownIcon__Lhp0c,
.page_newPageRightRow__\\+4WxM:has(.page_expanded__9LsFk) .page_dropdownIcon__Lhp0c {
    transform: rotate(-180deg);
}

.page_dropdownIcon__Lhp0c {
    transition: all 0.2s linear;
    width: 12px;
}

.page_expanded__9LsFk {
    max-height: 1000px;
    transition: max-height 0.8s ease-in-out 0s;
}

.page_collapse__2abR8 {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.6s ease-in-out 0s;
}

.page_urlInput__0TiF6 {
    display: block;
    width: 100%;
}

.page_adressInputBlock__ZTXol {
    position: relative;
}

.page_adressInputBlock__ZTXol .page_adressLink__41XCG {
    top: 24px;
}

.page_adressLink__41XCG,
.page_publication-Link__TkUiS .page_adressInputBlock__ZTXol .page_url-icon__iRmt4 {
    left: 14px;
    position: absolute;
    top: 1.48rem;
    width: 17px;
    height: 17px;
}

.page_adressInputBlock__ZTXol.page_urlInput__0TiF6>input {
    padding-left: 40px;
}

.page_adressInputBlock__ZTXol input,
.page_textExpert__2WRW5 {
    padding: 8px 12px;
    gap: 8px;
    height: 45px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-left: 40px;
    font-size: 14px;
}

.page_textExpert__2WRW5 {
    resize: vertical;
    overflow-x: hidden;
    min-height: calc(1.2em * 5);
    padding: 8px 12px;
}

.page_list-search__WjoSV p {
    color: #344054;
    font-size: 14px;
    line-height: 20px;
}

.page_newpageRight__cvvx3>.page_desktopFeatures__PNez2 {
    border-bottom: 1px solid #eaecf0;
}

.page_newpageRight__cvvx3>.page_desktopFeatures__PNez2:has(.page_expanded__9LsFk) {
    border-color: transparent;
}

.page_newpageRight__cvvx3>.page_newPageRight__kT3q9 {
    padding: 20px 30px;
}

.page_newPageRightRow__\\+4WxM.page_imageUploadBox__\\+mm3b {
    margin-top: 10px;
    height: 200px;
    position: relative;
    border: 1px solid black;
    border-radius: 6px;
}

.page_newpageImageUpload__H8Xvu {
    background: #fff;
    border: 1px solid #eaecf0;
    border-radius: 6px;
    box-shadow: 0 1px 3px #0000001a;
    min-height: 100%;
    max-width: 384px;
    position: relative;
    z-index: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.page_fileUploadCover_Img__zak1d {
    margin: 0 auto;
    display: block;
}

.page_fileUploadBox__GC\\+L8 .page_fileUploadCover_Img__zak1d {
    margin: 0 auto;
    background: #f2f4f7;
    border: 6px solid #f9fafb;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    padding: 5px !important;
    margin-bottom: 5px;
}

.page_newpageImageUpload__H8Xvu .page_featureImgMiddleContent__OdSRL,
.page_newpageImageUpload__H8Xvu div .page_newpage_CoverImg__u0Moj,
.page_newpageImageUpload__H8Xvu .page_featureImgMiddleContent__OdSRL,
.page_newpageImageUpload__H8Xvu div .page_newpage_CoverImg__u0Moj,
.page_newpageImageUpload__H8Xvu .page_featureImgMiddleContent__OdSRL,
.page_newpageImageUpload__H8Xvu div .page_newpage_CoverImg__u0Moj {
    width: 100%;
    height: 100%;
    min-height: 100%;
    max-width: 100%;
}

.page_newPageImageUploadText__Xja\\+w {
    font-weight: 400;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    color: #475467;
    -webkit-user-select: none;
            user-select: none;
    text-align: center;
    padding-top: 10px;
}

.page_newPageImageUploadText__Xja\\+w span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1c1c1c;
}

.page_contentDrop__k8t5R>div.page_scheduleCheckbox__d\\+V8y {
    margin-top: 9px;
    position: relative;
}

.page_listSearch__uVCPW label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
}

.page_listSearch__uVCPW input[type="checkbox"] {
    font-size: 0;
    width: 18px;
    height: 18px;
    border: 1px solid transparent;
    -o-appearance: none;
    appearance: none;
    position: relative;
    padding: 0 0 0 0;
    margin: 0;
    margin-right: 9px !important;
    box-shadow: none;
}

.page_listSearch__uVCPW input[type="checkbox"]:before {
    position: absolute;
    left: 0;
    top: -1px;
    margin-right: 0;
}

.page_scheduleCheckbox__d\\+V8y p {
    text-transform: unset;
}

.page_listSearch__uVCPW p {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
}

.page_verticleDots__l2GOi {
    position: relative;
    left: 0;
}

.page_pageListHeight__efKjD {
    overflow-y: hidden;
}

.page_pageDatatableList__hE5or {
    padding: 30px 30px 0;
}

.page_pageHeader__fkn38 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.page_pageHeader__fkn38 .page_pageHeading__rmI1m {
    font-size: 20px;
    font-weight: 600;
}

.page_pageHeader__fkn38 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.page_pageHeader__fkn38 .page_leftSide__H04Hx {
    display: flex;
    gap: 20px;
}

.page_searchBar__ee820 {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 8px 12px;
    gap: 8px;
    min-width: 250px;
    height: 40px;
}

.page_searchBar__ee820 img {
    width: 16px;
    height: 16px;
}

.page_searchBar__ee820 input {
    border: none;
    background: transparent;
    outline: none;
    flex: 1 1;
    font-size: 14px;
    color: #333;
}

.page_searchBar__ee820 input::placeholder {
    color: #999;
}

.page_addBtn__Zf0aR {
    background: #000;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
}

.page_actionButtonsDeleteAdd__dUZ5t {
    display: flex;
    align-items: center;
    gap: 10px;
}

.page_deleteSelectedBtn__ZMDDu {
    cursor: pointer;
}

/* Left side */
.page_editorBlock__mC6ro {
    /* max-width: 740px; */
    margin: auto;
    padding: 0 20px;
    margin-top: 30px;
    position: relative;
    top: 0;
}

#page_postTitle__SKqDq {
    font-style: normal;
    font-weight: 500;
    gap: 8px;
    outline: none;
    border: none;
    width: 100%;
    font-size: 36px;
    box-shadow: none;
    background: transparent;
    padding: 0;
    color: #1c1c1c;
    line-height: 48px;
}

.page_newpageLeftRow__pPj-L input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #667085;
    padding: 14px 14px 12px;
    gap: 8px;
    background: #fff;
    border-radius: 6px;
    outline: none;
    border: none;
    width: 100%;
}

.page_stockManage__wnkwK>div {
    display: flex;
    align-items: center;
    gap: 8px;
}

.page_stockManage__wnkwK input[type="checkbox"] {
    max-width: 18px;
    padding: 0;
    height: 18px;
}

.page_stockManage__wnkwK p{
    margin: 0;
}

#page_postTitle__SKqDq[placeholder]:empty:before {
    content: attr(placeholder);
    color: #667085;
}

.page_newpageRight__cvvx3>.page_newPageRightRow__\\+4WxM.page_bannerDropdownWrapper__wqhhR:has(.page_expanded__9LsFk),
.page_newpageRight__cvvx3>.page_newPageRightRow__\\+4WxM.page_bannerDropdownWrapper__wqhhR:has(.page_expanded__9LsFk) .page_contentDrop__k8t5R {
    overflow: visible;
}

.page_featuredImg__rnu23 {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 6px;
    object-fit: cover;
}

@media screen and (max-width: 1260px) {
    .page_newpageContent__lxhXc {
        margin-top: 30px;
        flex-direction: column;
    }

    .page_buttonsDesktop__Q0Iq3 {
        display: none;
    }

    .page_buttonsMobile__OjOU6 {
        display: block;
    }

    .page_newpageRight__cvvx3,
    .page_newpageLeft__oHlt9 {
        width: 100%;
        max-height: 100%
    }

    .page_newpageRight__cvvx3 .page_newPageRightRowURL__q143\\+ {
        border-top: 1px solid #e6e6e6;
    }

}

@media screen and (max-width: 1024px) {
    .page_newpageImageUpload__H8Xvu {
        margin-top: 15px;
    }

    .page_contentWrapper__zD0gX {
        margin-top: 0;
    }

}

@media screen and (max-width: 767px) {
    .page_newPageRightRow__\\+4WxM .page_newpageImageUpload__H8Xvu {
        margin-top: 10px;
        max-width: 100%;
    }

    .page_newpageRight__cvvx3>.page_desktopFeatures__PNez2 {
        margin-top: 0 !important;
    }

    .page_searchBar__ee820,
    .page_leftSide__H04Hx {
        width: calc(100% - 50px);
        min-width: calc(100% - 50px)
    }
}

@media screen and (max-width: 490) {
    .page_fileUploadCover_Img__zak1d {
        padding-top: 0 !important;
    }
}

@media screen and (max-width: 480) {
    .page_newPageRightRow__\\+4WxM .page_newpageImageUpload__H8Xvu {
        width: 100%;
        max-width: 100%;
    }
}

@media screen and (max-width: 390) {
    .page_fileUploadCover_Img__zak1d {
        padding-top: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Page/page.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mFAAmF;IACnF,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,8CAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;;;;;;IAMI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,SAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI,6BAA6B;IACjC;;AAEJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,wBAAwB;QACxB;IACJ;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".newpageContent {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0;\n    /* min-height: calc(100vh - 67px); */\n    min-height: 100vh;\n}\n\n.disabledNewpageLeft{\n    pointer-events: none;\n}\n\n.newpageRight {\n    border-left: 1px solid #e6e6e6;\n    margin-top: 0;\n    max-height: calc(100vh - 67px);\n    /* min-height: 100vh; */\n    padding: 0;\n    overflow-y: auto;\n    position: relative;\n    width: 410px;\n}\n\n.newpageLeft {\n    max-height: calc(100dvh - 100px);\n    overflow-y: auto;\n    /* margin-right: 36px; */\n    padding-right: 40px;\n    padding-left: 40px;\n    width: calc(100% - 410px);\n    padding-top: 30px;\n}\n\n.buttonsDesktop {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: block;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.buttonsMobile {\n    border-bottom: 1px solid #e6e6e6;\n    padding: 20px 30px;\n    display: none;\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n    z-index: 2;\n}\n\n.newpageRightButtons {\n    display: inline-flex;\n    position: relative;\n    height: 44px;\n}\n\n.newpageRightButtons button {\n    font-family: 'CyGrotesk-KeyRegular';\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 6px;\n}\n\n.newpageRightButtons button:first-child {\n    border-radius: 4px;\n    background: #0a0a0a;\n}\n\n.newpageRightButtons button:first-child {\n    /* background: #0a0a0a; */\n    margin-right: 8px;\n    /* min-width: 69px; */\n    min-height: 42px;\n    position: relative;\n    justify-content: center;\n    border-radius: 6px !important;\n}\n\n.newpageRightButtons .publishButton {\n    width: 97.3px;\n}\n\n.newpageRightButtons button {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 22px;\n    display: flex;\n    gap: 8px;\n    /* border-radius: 6px; */\n    align-items: center;\n    padding: 10px;\n    /* border: none; */\n    /* color: #fff; */\n    cursor: pointer;\n}\n\n.primaryButton {\n    box-shadow: 0 1px 3px #0000001a;\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n}\n\n.newpageRightButtons button:first-child p {\n    font-weight: 500;\n    margin: 0;\n}\n\n.newpageRightButtons button:nth-child(2) {\n    margin-right: 8px;\n}\n\n.newpageRightButtons .draftButton {\n    width: 120px;\n}\n\n.secondaryButton {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.updatePagebtn {\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.updateDraftButton {\n    background-color: #000;\n    color: #fff;\n    border-radius: 6px;\n    border: 1px solid #000;\n    box-shadow: 0 1px 3px #0000001a;\n}\n\n.newpageMoreButtons {\n    background-color: #fff;\n    color: #344054;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n    width: 44px;\n    height: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.actionDots {\n    width: 16px;\n    height: 16px;\n}\n\n.buttonsMobile .publishedButtonsList {\n    top: -90px;\n}\n\n.publishedButtonsList {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    background: #fff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    min-width: 150px;\n}\n\n.publishedButtonsList ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.publishedButtonsList li {\n    padding: 10px 15px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #344054;\n}\n\n.publishedButtonsList li:first-child {\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n}\n\n.publishedButtonsList li:last-child {\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n}\n\n.publishedButtonsList li:hover {\n    background-color: #f9fafb;\n}\n\n.publishStatus {\n    margin-top: 10px;\n    font-size: 14px;\n    color: #344054;\n    margin-bottom: 0;\n}\n\n.publishButton {\n    width: 97.3px;\n}\n\n.updatePagebtn {\n    width: 74.83px;\n}\n\n.updateDraftButton {\n    width: 116.92px;\n}\n\n.draftButton {\n    width: 120px;\n}\n\n.ringLoader {\n    width: 20px;\n    height: 20px;\n    border: 2px solid #f3f3f3;\n    border-top: 2px solid #000;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.newpageRight>.newPageRightRow {\n    border-bottom: 1px solid #e6e6e6;\n    border-top: 0;\n    overflow: hidden;\n    padding: 20px 30px;\n}\n\n.newPageRightFullUrl,\n.newPageRightTitle {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.iconDropWrap {\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    margin: 0;\n}\n\n.iconDropWrap span {\n    font-weight: 500;\n    margin-right: 3px;\n    width: calc(100% - 15px);\n    display: block;\n}\n\n.newPageRight:has(.expanded) .dropdownIcon,\n.newPageRightRow:has(.expanded) .dropdownIcon {\n    transform: rotate(-180deg);\n}\n\n.dropdownIcon {\n    transition: all 0.2s linear;\n    width: 12px;\n}\n\n.expanded {\n    max-height: 1000px;\n    transition: max-height 0.8s ease-in-out 0s;\n}\n\n.collapse {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.6s ease-in-out 0s;\n}\n\n.urlInput {\n    display: block;\n    width: 100%;\n}\n\n.adressInputBlock {\n    position: relative;\n}\n\n.adressInputBlock .adressLink {\n    top: 24px;\n}\n\n.adressLink,\n.publication-Link .adressInputBlock .url-icon {\n    left: 14px;\n    position: absolute;\n    top: 1.48rem;\n    width: 17px;\n    height: 17px;\n}\n\n.adressInputBlock.urlInput>input {\n    padding-left: 40px;\n}\n\n.adressInputBlock input,\n.textExpert {\n    padding: 8px 12px;\n    gap: 8px;\n    height: 45px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding-left: 40px;\n    font-size: 14px;\n}\n\n.textExpert {\n    resize: vertical;\n    overflow-x: hidden;\n    min-height: calc(1.2em * 5);\n    padding: 8px 12px;\n}\n\n.list-search p {\n    color: #344054;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.newpageRight>.desktopFeatures {\n    border-bottom: 1px solid #eaecf0;\n}\n\n.newpageRight>.desktopFeatures:has(.expanded) {\n    border-color: transparent;\n}\n\n.newpageRight>.newPageRight {\n    padding: 20px 30px;\n}\n\n.newPageRightRow.imageUploadBox {\n    margin-top: 10px;\n    height: 200px;\n    position: relative;\n    border: 1px solid black;\n    border-radius: 6px;\n}\n\n.newpageImageUpload {\n    background: #fff;\n    border: 1px solid #eaecf0;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px #0000001a;\n    min-height: 100%;\n    max-width: 384px;\n    position: relative;\n    z-index: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.fileUploadCover_Img {\n    margin: 0 auto;\n    display: block;\n}\n\n.fileUploadBox .fileUploadCover_Img {\n    margin: 0 auto;\n    background: #f2f4f7;\n    border: 6px solid #f9fafb;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n    padding: 5px !important;\n    margin-bottom: 5px;\n}\n\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg,\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg,\n.newpageImageUpload .featureImgMiddleContent,\n.newpageImageUpload div .newpage_CoverImg {\n    width: 100%;\n    height: 100%;\n    min-height: 100%;\n    max-width: 100%;\n}\n\n.newPageImageUploadText {\n    font-weight: 400;\n    text-align: center;\n    font-size: 14px;\n    line-height: 24px;\n    color: #475467;\n    user-select: none;\n    text-align: center;\n    padding-top: 10px;\n}\n\n.newPageImageUploadText span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #1c1c1c;\n}\n\n.contentDrop>div.scheduleCheckbox {\n    margin-top: 9px;\n    position: relative;\n}\n\n.listSearch label {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    cursor: pointer;\n}\n\n.listSearch input[type=\"checkbox\"] {\n    font-size: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid transparent;\n    -o-appearance: none;\n    appearance: none;\n    position: relative;\n    padding: 0 0 0 0;\n    margin: 0;\n    margin-right: 9px !important;\n    box-shadow: none;\n}\n\n.listSearch input[type=\"checkbox\"]:before {\n    position: absolute;\n    left: 0;\n    top: -1px;\n    margin-right: 0;\n}\n\n.scheduleCheckbox p {\n    text-transform: unset;\n}\n\n.listSearch p {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n}\n\n.verticleDots {\n    position: relative;\n    left: 0;\n}\n\n.pageListHeight {\n    overflow-y: hidden;\n}\n\n.pageDatatableList {\n    padding: 30px 30px 0;\n}\n\n.pageHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.pageHeader .pageHeading {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.pageHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.pageHeader .leftSide {\n    display: flex;\n    gap: 20px;\n}\n\n.searchBar {\n    display: flex;\n    align-items: center;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    gap: 8px;\n    min-width: 250px;\n    height: 40px;\n}\n\n.searchBar img {\n    width: 16px;\n    height: 16px;\n}\n\n.searchBar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    flex: 1;\n    font-size: 14px;\n    color: #333;\n}\n\n.searchBar input::placeholder {\n    color: #999;\n}\n\n.addBtn {\n    background: #000;\n    color: white;\n    padding: 10px 18px;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.actionButtonsDeleteAdd {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.deleteSelectedBtn {\n    cursor: pointer;\n}\n\n/* Left side */\n.editorBlock {\n    /* max-width: 740px; */\n    margin: auto;\n    padding: 0 20px;\n    margin-top: 30px;\n    position: relative;\n    top: 0;\n}\n\n#postTitle {\n    font-style: normal;\n    font-weight: 500;\n    gap: 8px;\n    outline: none;\n    border: none;\n    width: 100%;\n    font-size: 36px;\n    box-shadow: none;\n    background: transparent;\n    padding: 0;\n    color: #1c1c1c;\n    line-height: 48px;\n}\n\n.newpageLeftRow input {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #667085;\n    padding: 14px 14px 12px;\n    gap: 8px;\n    background: #fff;\n    border-radius: 6px;\n    outline: none;\n    border: none;\n    width: 100%;\n}\n\n.stockManage>div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.stockManage input[type=\"checkbox\"] {\n    max-width: 18px;\n    padding: 0;\n    height: 18px;\n}\n\n.stockManage p{\n    margin: 0;\n}\n\n#postTitle[placeholder]:empty:before {\n    content: attr(placeholder);\n    color: #667085;\n}\n\n.newpageRight>.newPageRightRow.bannerDropdownWrapper:has(.expanded),\n.newpageRight>.newPageRightRow.bannerDropdownWrapper:has(.expanded) .contentDrop {\n    overflow: visible;\n}\n\n.featuredImg {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    border-radius: 6px;\n    object-fit: cover;\n}\n\n@media screen and (max-width: 1260px) {\n    .newpageContent {\n        margin-top: 30px;\n        flex-direction: column;\n    }\n\n    .buttonsDesktop {\n        display: none;\n    }\n\n    .buttonsMobile {\n        display: block;\n    }\n\n    .newpageRight,\n    .newpageLeft {\n        width: 100%;\n        max-height: 100%\n    }\n\n    .newpageRight .newPageRightRowURL {\n        border-top: 1px solid #e6e6e6;\n    }\n\n}\n\n@media screen and (max-width: 1024px) {\n    .newpageImageUpload {\n        margin-top: 15px;\n    }\n\n    .contentWrapper {\n        margin-top: 0;\n    }\n\n}\n\n@media screen and (max-width: 767px) {\n    .newPageRightRow .newpageImageUpload {\n        margin-top: 10px;\n        max-width: 100%;\n    }\n\n    .newpageRight>.desktopFeatures {\n        margin-top: 0 !important;\n    }\n\n    .searchBar,\n    .leftSide {\n        width: calc(100% - 50px);\n        min-width: calc(100% - 50px)\n    }\n}\n\n@media screen and (max-width: 490) {\n    .fileUploadCover_Img {\n        padding-top: 0 !important;\n    }\n}\n\n@media screen and (max-width: 480) {\n    .newPageRightRow .newpageImageUpload {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 390) {\n    .fileUploadCover_Img {\n        padding-top: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newpageContent": `page_newpageContent__lxhXc`,
	"disabledNewpageLeft": `page_disabledNewpageLeft__3Azvl`,
	"newpageRight": `page_newpageRight__cvvx3`,
	"newpageLeft": `page_newpageLeft__oHlt9`,
	"buttonsDesktop": `page_buttonsDesktop__Q0Iq3`,
	"buttonsMobile": `page_buttonsMobile__OjOU6`,
	"newpageRightButtons": `page_newpageRightButtons__Sunh1`,
	"publishButton": `page_publishButton__44uWf`,
	"primaryButton": `page_primaryButton__q4DRZ`,
	"draftButton": `page_draftButton__80G-9`,
	"secondaryButton": `page_secondaryButton__WyTt6`,
	"updatePagebtn": `page_updatePagebtn__sw+iX`,
	"updateDraftButton": `page_updateDraftButton__1tL7S`,
	"newpageMoreButtons": `page_newpageMoreButtons__Pts8S`,
	"actionDots": `page_actionDots__IcHDJ`,
	"publishedButtonsList": `page_publishedButtonsList__0qaGl`,
	"publishStatus": `page_publishStatus__OWcDW`,
	"ringLoader": `page_ringLoader__nvw5P`,
	"spin": `page_spin__YhGqv`,
	"newPageRightRow": `page_newPageRightRow__+4WxM`,
	"newPageRightFullUrl": `page_newPageRightFullUrl__CG+gu`,
	"newPageRightTitle": `page_newPageRightTitle__Sg40q`,
	"iconDropWrap": `page_iconDropWrap__05wCG`,
	"newPageRight": `page_newPageRight__kT3q9`,
	"expanded": `page_expanded__9LsFk`,
	"dropdownIcon": `page_dropdownIcon__Lhp0c`,
	"collapse": `page_collapse__2abR8`,
	"urlInput": `page_urlInput__0TiF6`,
	"adressInputBlock": `page_adressInputBlock__ZTXol`,
	"adressLink": `page_adressLink__41XCG`,
	"publication-Link": `page_publication-Link__TkUiS`,
	"url-icon": `page_url-icon__iRmt4`,
	"textExpert": `page_textExpert__2WRW5`,
	"list-search": `page_list-search__WjoSV`,
	"desktopFeatures": `page_desktopFeatures__PNez2`,
	"imageUploadBox": `page_imageUploadBox__+mm3b`,
	"newpageImageUpload": `page_newpageImageUpload__H8Xvu`,
	"fileUploadCover_Img": `page_fileUploadCover_Img__zak1d`,
	"fileUploadBox": `page_fileUploadBox__GC+L8`,
	"featureImgMiddleContent": `page_featureImgMiddleContent__OdSRL`,
	"newpage_CoverImg": `page_newpage_CoverImg__u0Moj`,
	"newPageImageUploadText": `page_newPageImageUploadText__Xja+w`,
	"contentDrop": `page_contentDrop__k8t5R`,
	"scheduleCheckbox": `page_scheduleCheckbox__d+V8y`,
	"listSearch": `page_listSearch__uVCPW`,
	"verticleDots": `page_verticleDots__l2GOi`,
	"pageListHeight": `page_pageListHeight__efKjD`,
	"pageDatatableList": `page_pageDatatableList__hE5or`,
	"pageHeader": `page_pageHeader__fkn38`,
	"pageHeading": `page_pageHeading__rmI1m`,
	"leftSide": `page_leftSide__H04Hx`,
	"searchBar": `page_searchBar__ee820`,
	"addBtn": `page_addBtn__Zf0aR`,
	"actionButtonsDeleteAdd": `page_actionButtonsDeleteAdd__dUZ5t`,
	"deleteSelectedBtn": `page_deleteSelectedBtn__ZMDDu`,
	"editorBlock": `page_editorBlock__mC6ro`,
	"postTitle": `page_postTitle__SKqDq`,
	"newpageLeftRow": `page_newpageLeftRow__pPj-L`,
	"stockManage": `page_stockManage__wnkwK`,
	"bannerDropdownWrapper": `page_bannerDropdownWrapper__wqhhR`,
	"featuredImg": `page_featuredImg__rnu23`,
	"newPageRightRowURL": `page_newPageRightRowURL__q143+`,
	"contentWrapper": `page_contentWrapper__zD0gX`
};
export default ___CSS_LOADER_EXPORT___;
